export default __webpack_public_path__ + "assets/images/14ca02037fdcfc624d7c6cbe0d35078f.svg";